import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';

const Header = ({ onMenuClick }) => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  const getPageTitle = () => {
    const pathMap = {
      '/dashboard': 'Dashboard',
      '/pet-types': 'Pet Types',
      '/pet-breeds': 'Pet Breeds',
      '/states': 'States',
      '/cities': 'Cities',
      '/features': 'Features',
      '/pets': 'All Pets',
      '/users': 'Users',
    };
    return pathMap[location.pathname] || 'Dashboard';
  };

  const getUserInitials = () => {
    if (user?.fullName) {
      return user.fullName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase();
    }
    return 'AD';
  };

  return (
    <header className="header">
      <div className="header-left">
        <button
          className="btn btn-icon btn-secondary"
          onClick={onMenuClick}
          style={{ display: 'none' }}
        >
          <FiMenu />
        </button>
        <h1 className="header-title">{getPageTitle()}</h1>
      </div>

      <div className="header-right">
        <div className="header-user">
          <div className="header-avatar">{getUserInitials()}</div>
          <div className="header-user-info">
            <span className="header-user-name">{user?.fullName || 'Admin'}</span>
            <span className="header-user-role">{user?.role || 'Administrator'}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
